import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    messages: [],
    isAIResponding: false,
    capturedScreenshot: null,
    currentPromptType: null,
    userQuestion: "",
    smartActions: [],
    isGeneratingSmartActions: false,
    snapshots: [], // Array of { id, image, capturedAt }
    currentSnapshotId: null, // ID of the currently active snapshot
    selectedActionId: null, // ID of the currently highlighted action button
    suggestNewSnapshot: false, // Flag to show "new photo recommended" banner
};

const askAIReducerSlice = createSlice({
    name: "askAIReducer",
    initialState,
    reducers: {
        addMessage(state, action) {
            state.messages.push(action.payload);
        },
        setIsAIResponding(state, action) {
            state.isAIResponding = action.payload;
        },
        setCapturedScreenshot(state, action) {
            state.capturedScreenshot = action.payload;
        },
        setCurrentPromptType(state, action) {
            state.currentPromptType = action.payload;
        },
        setUserQuestion(state, action) {
            state.userQuestion = action.payload;
        },
        clearScreenshot(state) {
            state.capturedScreenshot = null;
            state.userQuestion = "";
            state.currentPromptType = null;
        },
        resetPromptSelection(state) {
            state.currentPromptType = null;
            state.capturedScreenshot = null;
            state.userQuestion = "";
        },
        setSmartActions(state, action) {
            state.smartActions = action.payload;
        },
        setIsGeneratingSmartActions(state, action) {
            state.isGeneratingSmartActions = action.payload;
        },
        clearSmartActions(state) {
            state.smartActions = [];
            state.isGeneratingSmartActions = false;
        },
        addSnapshot(state, action) {
            state.snapshots.push(action.payload);
            state.currentSnapshotId = action.payload.id;
        },
        setSelectedActionId(state, action) {
            state.selectedActionId = action.payload;
        },
        clearSelectedActionId(state) {
            state.selectedActionId = null;
        },
        setSuggestNewSnapshot(state, action) {
            state.suggestNewSnapshot = action.payload;
        },
        hideSnapshotHeaderBubble(state) {
            // Hide ALL Smart Actions bubbles (both with and without headers)
            state.messages.forEach((msg) => {
                if (msg.type === "SMART_ACTIONS") {
                    msg.hidden = true;
                }
            });
        },
        resetAskAIReducer() {
            return initialState;
        },
    },
});

export const {
    addMessage,
    setIsAIResponding,
    setCapturedScreenshot,
    setCurrentPromptType,
    setUserQuestion,
    clearScreenshot,
    resetPromptSelection,
    setSmartActions,
    setIsGeneratingSmartActions,
    clearSmartActions,
    addSnapshot,
    setSelectedActionId,
    clearSelectedActionId,
    setSuggestNewSnapshot,
    hideSnapshotHeaderBubble,
    resetAskAIReducer,
} = askAIReducerSlice.actions;

export default askAIReducerSlice.reducer;
